import { render, staticRenderFns } from "./SectionTestimonies.vue?vue&type=template&id=0496a92f&scoped=true"
import script from "./SectionTestimonies.vue?vue&type=script&lang=js"
export * from "./SectionTestimonies.vue?vue&type=script&lang=js"
import style0 from "./SectionTestimonies.vue?vue&type=style&index=0&id=0496a92f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496a92f",
  null
  
)

export default component.exports